module.exports = __webpack_public_path__ + "img/bromide_logo_referrer.acd0d416.png";